<template>
  <div>
    <search hide placeholder="请输入食物名称" v-model="params.search" @search="handleSearch"></search>
    <div class="eating-list">
      <div class="eating-list-item" v-for="(item) in list" :key="item.id" @click="handleItemClick(item)">
        <div class="eating-list-item-top">
          <img :src="item.resp_img" alt="">
          <div class="eating-list-item-main">
            <p class="title">{{item.title}}</p>
            <p class="eating-list-item-main-text" v-html="item.content"></p>
          </div>
        </div>
        <div class="eating-list-item-footer">
          <div class="eating-list-item-icon">
            <img :src="iconList[`${item['nbnctags']['pregnant']-1}`]" alt="icon-0.png">
            <p>孕妇</p>
          </div>
          <div class="eating-list-item-icon">
            <img :src="iconList[`${item['nbnctags']['puerpera']-1}`]" alt="icon-0.png">
            <p>产妇</p>
          </div>
          <div class="eating-list-item-icon">
            <img :src="iconList[`${item['nbnctags']['lactation']-1}`]" alt="icon-0.png">
            <p>哺乳</p>
          </div>
          <div class="eating-list-item-icon">
            <img :src="iconList[`${item['nbnctags']['baby']-1}`]" alt="icon-0.png">
            <p>婴幼儿</p>
          </div>
        </div>
      </div>
      <vux-load-more :tip="loadMore.tip" v-show="loadMore.show" :show-loading="!loadMore.isDone"></vux-load-more>
      <no-data v-if="showNodata" :text="$route.query.search"></no-data>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import { getArticleList } from './api/index'
  import VuxLoadMore from 'vux/src/components/load-more'
  import NoData from '@/pages/Eating/components/NoData'
  import Search from './components/Search'

  const TIPS = {
    loading: '正在加载',
    done: '我是有底线的～'
  }

  export default {
    name: 'EatingList',
    inject: ['search'],
    components: {
      NoData,
      VuxLoadMore,
      Search
    },
    data () {
      return {
        id: '',
        list: [],
        params: {
          page: 1,
          search: ''
        },
        iconList: [
          require(`@/assets/eating/icon-0.png`),
          require(`@/assets/eating/icon-1.png`),
          require(`@/assets/eating/icon-2.png`),
        ],
        loadMore: {
          show: false,
          isFetching: false,
          isDone: false,
          tip: TIPS.loading
        }
      }
    },
    computed: {
      showNodata () {
        return this.params.page === 1 && this.loadMore.isDone
      }
    },
    created () {
      this.id = this.$route.query.id
      this.params.search = this.$route.query.search
      this.fetchData()
    },
    mounted () {
      this.listenScroll()
    },
    methods: {
      fetchData () {
        this.loadMore.isFetching = true
        this.loadMore.show = true
        getArticleList({ ...this.params, cid: this.id, search: this.params.search })
          .then(res => {
            const data = res.data.data.data

            if (!data.length) {
              this.loadMore.isDone = true
              this.loadMore.tip = TIPS.done
              if (this.params.page === 1) {
                this.loadMore.show = false
              }
              return false
            } else {
              this.loadMore.isDone = false
              this.loadMore.tip = TIPS.loading
              this.loadMore.show = false
            }

            this.list = [...this.list, ...data]
            this.params.page++
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.loadMore.isFetching = false
          })
      },
      pullUp () {
        if (this.loadMore.isFetching || this.loadMore.isDone) return false
        this.fetchData()
      },
      listenScroll () {
        const el = document.querySelector('.eating-list')
        const _this = this
        el.onscroll = function (e) {
          const scrollTop = e.target.scrollTop
          const offsetHeight = e.target.offsetHeight
          const scrollHeight = e.target.scrollHeight
          const threshold = 40
          if (scrollTop + offsetHeight + threshold >= scrollHeight) {
            _this.pullUp()
          }
        }
      },
      handleSearch (val) {
        if (val.trim() === '') return
        if (val === this.$route.query.search) return;

        const params = {
          id: this.id,
          search: val
        }
        this.$router.push({
          path: `/eating/list?${qs.stringify(params)}`
        })
      },
      handleItemClick (item) {
        this.$router.push({
          path: `/eating/detail?id=${item.id}&cid=${this.id}`
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "./styles/index";

  .eating-list {
    p {
      margin: 0;
    }

    padding: 0 pxTOvw(30px);
    overflow: auto;
    height: calc(100vh - 52px);

    &-item {
      border-bottom: 1px solid #eee;
      padding-top: pxTOvw(30px);

      &-top {
        display: flex;
        align-items: center;

        img {
          width: pxTOvw(154px);
          height: pxTOvw(154px);
          margin-right: pxTOvw(20px);
        }
      }

      &-main {
        flex: 1;
        color: #666;
        font-size: pxTOvw(28px);

        &-text {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-indent: 0.8em;
        }

        .title {
          color: #000;
          font-size: pxTOvw(33px);
          margin-bottom: pxTOvw(12px);
        }
      }

      &-footer {
        display: flex;
      }

      &-icon {
        width: 25%;
        display: flex;
        align-items: center;
        font-size: pxTOvw(31px);
        padding: pxTOvw(26px) pxTOvw(8px);

        img {
          width: 1.3em;
          height: 1.3em;
          margin-right: pxTOvw(6px);
          color: #333;
        }
      }

    }
  }
</style>
